import {
	type EnvironmentConfig,
	type LogFunction,
	type MutableRecordSource,
	type OperationLoader,
	RecordSource,
	RelayFeatureFlags,
	type RelayFieldLogger,
} from 'relay-runtime';
import LiveResolverStore, {
	type ActorIdentifier,
	type GetDataID,
	// @ts-ignore
} from 'relay-runtime/lib/store/live-resolvers/LiveResolverStore';
import type { Scheduler } from 'relay-runtime/lib/store/RelayStoreTypes';

import RelayDataID from '@atlassian/relay-data-id';
import RelayMissingFieldHandlers from '@atlassian/relay-missing-field-handlers';
import { network as defaultNetwork } from '@atlassian/relay-network';
import RelayScheduler from '@atlassian/relay-scheduler';

// Enable Relay Resolvers globally for this module
RelayFeatureFlags.ENABLE_RELAY_RESOLVERS = true;

type Props = {
	log?: EnvironmentConfig['log'];
	requiredFieldLogger?: RelayFieldLogger;
	network?: EnvironmentConfig['network'];
	getDataID?: EnvironmentConfig['getDataID'];
	recordSource?: RecordSource;
};

const createStore = (
	source: MutableRecordSource,
	options?: {
		actorIdentifier?: ActorIdentifier;
		gcReleaseBufferSize?: number;
		gcScheduler?: Scheduler;
		getDataID?: GetDataID;
		log?: LogFunction;
		operationLoader?: OperationLoader;
		queryCacheExpirationTime?: number;
		shouldProcessClientComponents?: boolean;
		treatMissingFieldsAsNull?: boolean;
	},
) => {
	return new LiveResolverStore(source, options);
};

// @deprecated Use createRelayEnvironment from @atlassian/relay-environment/createRelayEnvironment instead
export function getDefaultRelayEnvironmentConfig({
	log,
	requiredFieldLogger,
	network,
	getDataID,
	recordSource,
}: Props): EnvironmentConfig {
	return {
		configName: 'Atlassian Graphql Gateway',
		network: network || defaultNetwork,
		store: createStore(recordSource || new RecordSource(), {
			log: log ?? undefined,
			getDataID: getDataID ?? RelayDataID,
		}),
		log,
		relayFieldLogger: requiredFieldLogger,
		getDataID: getDataID ?? RelayDataID,
		scheduler: RelayScheduler,
		missingFieldHandlers: RelayMissingFieldHandlers,
	};
}
